import fetch from '@/config/fetchNew';

export const messageList = data => fetch('/sys/comment/list', data, 'POST');
